import { IHttpApi } from '@cian/http-api';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  fetchChangeOffersOrder,
  TChangeOffersOrderRequest,
  TChangeOffersOrderResponse,
} from '../../repositories/offers-comparison/v1/change-offers-order';
import { IErrorResponseSchema } from '../../repositories/offers-comparison/entities/schemas/ErrorResponseSchema';

interface IChangeOffersOrderRequestParams {
  httpApi: IHttpApi;
  parameters: TChangeOffersOrderRequest;
}

export const fetchChangeOffersOrderService = async (
  { httpApi, parameters }: IChangeOffersOrderRequestParams,
  retries?: number,
): Promise<void> => {
  try {
    const response: TChangeOffersOrderResponse = await fetchChangeOffersOrder({ httpApi, parameters });

    if (response.statusCode === 400) {
      throw new HttpBadStatusCodeError({
        statusCode: response.statusCode,
        domain: 'src/shared/services/compare#fetchChangeOffersOrderService',
        message: (response.response as IErrorResponseSchema).message || '',
      });
    }
  } catch (err) {
    if (retries && retries > 1) {
      await fetchChangeOffersOrderService({ httpApi, parameters }, retries - 1);
    } else {
      throw err;
    }
  }
};
